<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Transaksi QRIS</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 50px"
            >
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Jumlah Transaksi</span>
                            </div>
                            <h1 class="total">
                                <span>{{
                                    qris_payments_summary.count_of_trx | rupiah
                                }}</span>
                            </h1>
                        </div>
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Total Transaksi</span>
                            </div>
                            <h1 class="total">
                                <span
                                    >Rp
                                    {{
                                        qris_payments_summary.sum_of_trx
                                            | rupiah
                                    }}</span
                                >
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 50px">
                <div class="section mt-2">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <datetime
                                        v-model="qris_payments_meta.startDate"
                                        class="theme-primary"
                                        :input-class="'form-control'"
                                        auto
                                        :title="'Mulai Tanggal'"
                                    ></datetime>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <datetime
                                        v-model="qris_payments_meta.endDate"
                                        class="theme-primary"
                                        :input-class="'form-control'"
                                        auto
                                        :title="'Sampai Tanggal'"
                                    ></datetime>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ButtonLoader
                        :loading="loadingButtonFilter"
                        :styled="'btn btn-primary btn-block mt-1'"
                        @click.native="submitFilterData()"
                    >
                        Filter Data</ButtonLoader
                    >
                </div>
                <div class="section full mt-3">
                    <div>
                        <div
                            class="text-center mt-5 pt-5 mb-5 pb-5"
                            v-if="loadingData"
                        >
                            <span
                                class="spinner-border spinner-border mr-1 text-primary"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        </div>
                        <div v-else-if="qris_payments.data.length > 0">
                            <!-- item -->
                            <ul
                                class="listview image-listview-product full ml-0 mr-0"
                            >
                                <li
                                    v-for="item in qris_payments.data"
                                    :key="item.id"
                                >
                                    <router-link
                                        :to="{
                                            name: 'qris.payment.detail',
                                            params: {
                                                id: item.id,
                                            },
                                        }"
                                        class="item pl-2 pr-3 pt-2 pb-2"
                                    >
                                        <div class="in">
                                            <div style="width: 90%">
                                                <header>
                                                    {{ item.paid_at | date }}
                                                    ({{ item.paid_at | time }}
                                                    WIB)
                                                </header>
                                                <b>{{
                                                    item.qris_merchant
                                                        .merchant_name
                                                }}</b>
                                                <footer>
                                                    <div>
                                                        Issuer :
                                                        {{
                                                            JSON.parse(
                                                                item.reference_data
                                                            ).issuer
                                                        }}
                                                    </div>
                                                    <div>
                                                        RRN :
                                                        {{
                                                            JSON.parse(
                                                                item.reference_data
                                                            ).rrn
                                                        }}
                                                    </div>
                                                </footer>
                                            </div>
                                        </div>
                                        <span class="text-muted text-right">
                                            <h4>
                                                Rp
                                                {{ item.amount | rupiah }}
                                            </h4>
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                            <div
                                class="m-2 text-center"
                                v-if="
                                    qris_payments.next_page_url &&
                                    qris_payments.to >= qris_payments.per_page
                                "
                            >
                                <ButtonLoader
                                    :loading="loading.pagination"
                                    :styled="'btn btn-primary rounded mr-1 mb-1'"
                                    @click.native="
                                        getQrisPayment(
                                            qris_payments.next_page_url
                                        )
                                    "
                                    >Lihat lebih banyak</ButtonLoader
                                >
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <img
                                :src="require('@/assets/image/empty.webp')"
                                alt="404"
                                class="w-50"
                            /><br />
                            <h4 class="mb-0 text-secondary">
                                Belum ada transaksi
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
                loadingButtonFilter: false,
                loadingData: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.getQrisPaymentSummary();
            this.getQrisPayment().then(() => {
                this.loadingApp = false;
            });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_payments_summary: state => state.qris_payments_summary,
                qris_payments: state => state.qris_payments,
                qris_payments_meta: state => state.qris_payments_meta,
                loading: state => state.loading,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', [
                'getQrisPayment',
                'getQrisPaymentSummary',
            ]),
            ...mapMutations('qrisMerchant', [
                'RESET_QRIS_PAYMENT',
                'RESET_QRIS_PAYMENT_META',
            ]),
            submitFilterData() {
                this.RESET_QRIS_PAYMENT();
                this.loadingData = true;
                this.loadingButtonFilter = true;
                this.getQrisPaymentSummary();
                this.getQrisPayment().then(() => {
                    this.loadingData = false;
                    this.loadingButtonFilter = false;
                });
            },
        },

        mounted() {},
        destroyed() {
            this.RESET_QRIS_PAYMENT();
            this.RESET_QRIS_PAYMENT_META();
        },
    };
</script>
<style>
    .theme-primary .vdatetime-popup__header,
    .theme-primary .vdatetime-calendar__month__day--selected > span > span,
    .theme-primary
        .vdatetime-calendar__month__day--selected:hover
        > span
        > span {
        background: #0b8bcc;
    }

    .theme-primary .vdatetime-year-picker__item--selected,
    .theme-primary .vdatetime-time-picker__item--selected,
    .theme-primary .vdatetime-popup__actions__button {
        color: #0b8bcc;
    }
</style>
